import * as React from 'react';
import {Component, deps, inject, observer} from '../lib/component';
import {Loading} from '../components/loading/loading';
import {style} from 'typestyle';
import {center, centerJustified, vertical} from 'csstips';
import {rem, viewHeight} from 'csx';
import {gradientDark} from '../theme/gradient';
import MainWrapper from '../components/main-wrapper';
import {colorBackground, colorContrast} from '../theme/color';

export interface SigninPageProps {}

@inject(deps) @observer
export class SigninPage extends Component<SigninPageProps> {
  render() {
    const {hasError, loading} = this.props.model.page.signin;

    return (
        <MainWrapper className={SigninPage.styles.container}>
          {loading && (
              <div>
                <Loading light={true}/>
                <p className={SigninPage.styles.info}>Just loading your profile, hang on!</p>
                <p style={{textAlign: "center"}}>(this window will close itself...)</p>
              </div>
          )}

          {hasError && (
              <div>
                <p className={SigninPage.styles.info}>We could not find any channels associated with that Google account.</p>
                <p className={SigninPage.styles.info}>Click <a href="/">here</a> to return and try again with a different
                  account.</p>
              </div>
          )}
        </MainWrapper>
    )
  }

  static styles = {
    container: style({
      ...vertical,
      ...center,
      ...centerJustified,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99,
      minHeight: viewHeight(80),
      background: gradientDark,
      $nest: {
        '& a': {
          color: colorContrast.toString()
        }
      }
    }),
    info: style({
      margin: '1rem 1rem 0',
      color: colorBackground.toString()
    })
  }
}